import { PHONE_NUMBER_REGEX } from '@/helpers/constants/regex';

export const sanitizePhoneInput = (value: string) => {
  const cleaned = value.replace(/[^\d+]/g, '').replace(/(\+.*)\+/g, '$1');

  if (!cleaned) return cleaned;

  if (cleaned === '+') return cleaned;

  if (cleaned.startsWith('+')) {
    let digits = cleaned.slice(1);

    if (!digits) return cleaned;

    const firstDigit = digits[0];

    if (firstDigit === '1') {
      digits = digits.slice(0, 11);
    } else if (firstDigit === '9') {
      digits = digits.slice(0, 12);
    } else {
      digits = digits.slice(0, 12);
    }

    return `+${digits}`;
  }

  return cleaned.slice(0, 10);
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const isPhoneNumberInputPotentiallyValid = (value: string) => {
  if (!value) return true;

  if (value === '+') return true;

  if (value.startsWith('+')) {
    const digits = value.slice(1);

    if (!/^\d*$/.test(digits)) return false;
    if (!digits) return true;

    const firstDigit = digits[0];

    if (firstDigit === '1') {
      return digits.length <= 11;
    }

    if (firstDigit === '9') {
      if (digits.length === 1) return true;

      if (digits[1] !== '2') return false;

      return digits.length <= 12;
    }

    return false;
  }

  return /^\d{0,10}$/.test(value);
};

export const isCompletePhoneNumber = (value: string) => PHONE_NUMBER_REGEX.test(value);
